import { render } from "./CreateTeamMember.vue?vue&type=template&id=6c092d00"
import script from "./CreateTeamMember.vue?vue&type=script&lang=js"
export * from "./CreateTeamMember.vue?vue&type=script&lang=js"
script.render = render

export default script